export default "/_next/static/chunks/fonts/EvilIcons-699664b33ac2837d5bee07bd937a756a.ttf";